export class WalletConnectChainRegistry {
    constructor() {
        this.definitions = new Map();
    }
    register(definition) {
        if (!definition.namespace)
            throw new Error('WalletConnect chain namespace is required');
        this.definitions.set(definition.namespace, definition);
    }
    get(namespace) { return this.definitions.get(namespace); }
}
export const defaultWalletConnectChainRegistry = new WalletConnectChainRegistry();
